import { api } from "../api";

export type FeedbackType = "thought" | "feature_wish" | "problem" | "general";

export interface FeedbackSubmissionRequest {
  feedback_text: string;
  feedback_type: FeedbackType;
}

export interface FeedbackSubmissionResponse {
  id: string;
  message: string;
  created_at: string;
}

export const submitFeedback = async (
  data: FeedbackSubmissionRequest
): Promise<FeedbackSubmissionResponse> => {
  return api.post("api/feedback", { json: data }).json<FeedbackSubmissionResponse>();
};






